import { unwrapData } from '@noor/api';
import type * as z from 'zod';

/** Core may wrap a payload in { data, meta }; the policy service also serves bare JSON. */
export function parseRbacResponse<T extends z.ZodType>(
  schema: T,
  raw: unknown,
): z.output<T> {
  return schema.parse(unwrapData(raw));
}
